import { render, staticRenderFns } from "./gzzoc-eye-neoplasms.vue?vue&type=template&id=6be9626c&scoped=true&lang=pug&"
import script from "./gzzoc-eye-neoplasms.vue?vue&type=script&lang=js&"
export * from "./gzzoc-eye-neoplasms.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-eye-neoplasms.vue?vue&type=style&index=0&id=6be9626c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be9626c",
  null
  
)

export default component.exports